import OpacityAnimation from '../../../../../components/OpacityAnimation';
import Pagination from '../../../../../components/Pagination';
import { MappedActivityRating } from '../../types';
import { Header } from './styles';

interface ListHeaderInterface {
  doesListExists: boolean;
  hasError: boolean;
  singularLabel: string;
  pluralLabel: string;
  pagesQuantity: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  ratingsSplited: Array<MappedActivityRating[]>;
}

export default function ListHeader({
  doesListExists,
  hasError,
  singularLabel,
  pluralLabel,
  pagesQuantity,
  currentPage,
  onPageChange,
  ratingsSplited,
}: ListHeaderInterface) {
  const total = ratingsSplited?.flat().length || 0;
  
  return (
    <OpacityAnimation delay={0.1}>
      <Header doesListExists={doesListExists} apiFetched={!hasError}>
        {doesListExists && (
          <div className="leftAlignment">
            <strong>
              {total || 0}
              {' '}
              {total === 1 ? singularLabel : pluralLabel}
            </strong>
            <Pagination
              pagesQuantity={pagesQuantity}
              handlePageChange={onPageChange}
              currentPage={currentPage}
            />
            ({(currentPage + 1) * 100 - 99}-{(currentPage + 1) * 100 > total ? total : (currentPage + 1) * 100})
          </div>
        )}
      </Header>
    </OpacityAnimation>
  );
}
